import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { TemplateUtenteProfilo } from '../../../models/profili-utente/template-utente-profilo';
import { UtenteProfilo } from '../../../models/profili-utente/utente-profilo';
import { UtenteProfiloTemplate } from '../../../models/profili-utente/utente-profilo-template';
import { TemplateUtenteAddComponent } from '../template-utente-add/template-utente-add.component';
import { UtenteAddComponent } from './utente-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [utente-mod-add]',
  templateUrl: 'utente-mod-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class UtenteModAddComponent {
  @Output() onReturnUtente: EventEmitter<UtenteProfiloTemplate> = new EventEmitter<UtenteProfiloTemplate>();
  @ViewChild('formAddUtente') modaleUtente: UtenteAddComponent;
  @Output() onReturn: EventEmitter<UtenteProfilo> = new EventEmitter<UtenteProfilo>();
  @ViewChild('formAddTemplateUtente') modaleTemplateUtente: TemplateUtenteAddComponent;
  public templateView: boolean;
  private urlAdd: string;

  inizializza(urlAdd: string, urlGetTemplates: string, urlGetTemplate: string, utente: UtenteProfilo, templateUtente: TemplateUtenteProfilo) {
    this.templateView = false;
    this.urlAdd = urlAdd;
    this.modaleUtente.inizializza(urlAdd, urlGetTemplates, urlGetTemplate, utente);
    openModal('modalmodaddutente');
  }

  createForm() {
    this.modaleUtente.createForm();
  }

  manageModalUtente(utenteProfiloTemplate: UtenteProfiloTemplate) {
      this.templateView = true;
      this.onReturnUtente.emit(utenteProfiloTemplate);
      this.modaleTemplateUtente.inizializza(this.urlAdd, utenteProfiloTemplate.utente, utenteProfiloTemplate.templateProfilo);
  }

  manageModal(templateUtente: UtenteProfilo) {
      closeModal('modalmodaddutente');
      this.onReturn.emit(templateUtente);
      this.templateView = false;
  }
}
